import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import SiteHeader from "./components/SiteHeader";
import Footer from "./components/footer";
import HomePage from "./pages/HomePage";
import Tours from "./pages/tours";
import TourDetail from "./pages/tourDetail";
import Destinations from "./pages/destinations";
import Safaris from "./pages/safaris";
import NorthernCircuits from "./pages/safaris/northern-circuits";
import SouthernCircuits from "./pages/safaris/southern-circuits";
import BeachAndSafari from "./pages/safaris/beach-and-safari";
import Serengeti from "./pages/safaris/northern-circuits/serengeti";
import Ngorongoro from "./pages/safaris/northern-circuits/ngorongoro";
import Tarangire from "./pages/safaris/northern-circuits/tarangire";
import LakeManyara from "./pages/safaris/northern-circuits/lake-manyara";
import Ruaha from "./pages/safaris/southern-circuits/ruaha";
import Nyerere from "./pages/safaris/southern-circuits/nyerere";
import Mikumi from "./pages/safaris/southern-circuits/mikumi";
import Trekking from "./pages/trekking";
import Kilimanjaro from "./pages/trekking/kilimanjaro";
import Meru from "./pages/trekking/meru";
import OlDionyoLengai from "./pages/trekking/ol-dionyo-lengai";
import Trips from "./pages/trips";
import About from "./pages/about";
import Contact from "./pages/contact";
import NotFound from "./pages/notFound";
import "./App.css";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function AppShell() {
  const { pathname } = useLocation();

  return (
    <div className="App">
      <SiteHeader />
      <main className="site-main" key={pathname}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/tours/:id" element={<TourDetail />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/safaris" element={<Safaris />} />
          <Route
            path="/safaris/northern-circuits"
            element={<NorthernCircuits />}
          />
          <Route
            path="/safaris/northern-circuits/serengeti"
            element={<Serengeti />}
          />
          <Route
            path="/safaris/northern-circuits/ngorongoro"
            element={<Ngorongoro />}
          />
          <Route
            path="/safaris/northern-circuits/tarangire"
            element={<Tarangire />}
          />
          <Route
            path="/safaris/northern-circuits/lake-manyara"
            element={<LakeManyara />}
          />
          <Route
            path="/safaris/southern-circuits"
            element={<SouthernCircuits />}
          />
          <Route path="/safaris/southern-circuits/ruaha" element={<Ruaha />} />
          <Route
            path="/safaris/southern-circuits/nyerere"
            element={<Nyerere />}
          />
          <Route
            path="/safaris/southern-circuits/mikumi"
            element={<Mikumi />}
          />
          <Route
            path="/safaris/beach-and-safari"
            element={<BeachAndSafari />}
          />
          <Route path="/trekking" element={<Trekking />} />
          <Route path="/trekking/kilimanjaro" element={<Kilimanjaro />} />
          <Route path="/trekking/meru" element={<Meru />} />
          <Route
            path="/trekking/ol-dionyo-lengai"
            element={<OlDionyoLengai />}
          />
          <Route path="/trips" element={<Trips />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
